// Number answers of a checklist are typed the German way ("12,5", "1.234,5"),
// while the backend stores a plain number. `Number("12,5")` is NaN, which was
// silently saved as 0 — so parsing lives here, in one place.

/**
 * @returns {number|null} the typed number, or null when it isn't one (empty,
 *   "-", "1,2,3", …). With a comma, the comma is the decimal mark and dots are
 *   thousands separators; without one, a dot stays the decimal mark ("12.5").
 */
export const parseChecklistNumber = input => {
  const text = `${input ?? ""}`.trim();
  if (!text) return null;
  const normalized = text.includes(",")
    ? text.replace(/\./g, "").replace(",", ".")
    : text;
  if (!/^-?(\d+(\.\d*)?|\.\d+)$/.test(normalized)) return null;
  const value = Number(normalized);
  return Number.isFinite(value) ? value : null;
};

/** A saved number as the user types it: 12.5 → "12,5". */
export const formatChecklistNumber = value =>
  value === undefined || value === null || value === "" || !Number.isFinite(Number(value))
    ? ""
    : String(value).replace(".", ",");
